
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.817.023a.837.837 0 00-.55.244.837.837 0 000 1.184l4.449 4.452H2.439a.837.837 0 00-.837.837.837.837 0 00.837.837h4.3a.837.837 0 00.838-.837V2.439a.837.837 0 00-.837-.837.837.837 0 00-.837.837v2.28L1.45.267A.837.837 0 00.817.023zm10.451 10.409a.837.837 0 00-.837.837v4.3a.837.837 0 00.837.838.837.837 0 00.837-.837v-2.28l4.452 4.451a.837.837 0 001.183 0 .837.837 0 000-1.184l-4.451-4.451h2.28a.837.837 0 00.837-.837.837.837 0 00-.837-.837z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    